/*
 * Converte uma lista de <article> em abas.
 *
 * O servidor manda tudo empilhado, com título e conteúdo — legível de cima a
 * baixo sem script nenhum. Aqui a gente promove os títulos a botões de aba e
 * esconde os painéis inativos. Se este arquivo não carregar, a página continua
 * inteira; só não tem abas.
 *
 * O `hidden` sozinho não basta para esconder os painéis: qualquer classe com
 * `display` vence o atributo (armadilha nº 3 da BIBLIOTECA-COMPONENTES.md).
 * Por isso escondemos com a classe .yasy-aba-oculta, que tem display próprio.
 */
(function () {
  'use strict';

  var raiz = document.querySelector('[data-yasy-abas]');
  if (!raiz) return;

  var artigos = raiz.querySelectorAll('[data-aba]');
  if (artigos.length < 2) return;

  var lista = document.createElement('div');
  lista.className = 'mb-8 flex flex-wrap justify-center gap-2';
  lista.setAttribute('role', 'tablist');

  var botoes = [];

  function ativar(indice, mover) {
    botoes.forEach(function (b, i) {
      var ativo = i === indice;
      b.setAttribute('aria-selected', ativo ? 'true' : 'false');
      b.setAttribute('tabindex', ativo ? '0' : '-1');
      artigos[i].classList.toggle('yasy-aba-oculta', !ativo);
    });
    if (mover) botoes[indice].focus();
  }

  Array.prototype.forEach.call(artigos, function (artigo, i) {
    var titulo = artigo.querySelector('[data-aba-titulo]');
    if (!titulo) return;

    var id = artigo.id || 'aba-' + i;
    artigo.id = id;

    var b = document.createElement('button');
    b.type = 'button';
    b.textContent = titulo.textContent.trim();
    b.id = id + '-botao';
    b.className = 'yasy-btn yasy-aba-btn';
    b.setAttribute('role', 'tab');
    b.setAttribute('aria-controls', id);

    b.addEventListener('click', function () { ativar(i, false); });
    lista.appendChild(b);
    botoes.push(b);

    /* O título vira o rótulo da aba; mantido no DOM para leitor de tela, fora
       da tela para não repetir o que o botão já mostra. */
    titulo.classList.add('sr-only');

    artigo.setAttribute('role', 'tabpanel');
    artigo.setAttribute('aria-labelledby', b.id);
    artigo.classList.remove('border-b', 'border-primary/15');
  });

  if (!botoes.length) return;

  /* Setas navegam entre abas, como manda o padrão de tablist. */
  lista.addEventListener('keydown', function (e) {
    var atual = botoes.findIndex(function (b) { return b.getAttribute('aria-selected') === 'true'; });
    var proximo = null;
    if (e.key === 'ArrowRight') proximo = (atual + 1) % botoes.length;
    else if (e.key === 'ArrowLeft') proximo = (atual - 1 + botoes.length) % botoes.length;
    else if (e.key === 'Home') proximo = 0;
    else if (e.key === 'End') proximo = botoes.length - 1;
    if (proximo === null) return;
    e.preventDefault();
    ativar(proximo, true);
  });

  raiz.insertBefore(lista, raiz.firstChild);

  /* Link direto para uma aba: /produto#aba-xxxx */
  var alvo = 0;
  if (location.hash) {
    var achou = Array.prototype.findIndex.call(artigos, function (a) { return '#' + a.id === location.hash; });
    if (achou > -1) alvo = achou;
  }
  ativar(alvo, false);
})();
